import { useEffect, useLayoutEffect } from 'react';

export const IS_SERVER = typeof document === 'undefined';

export const useLayoutEffectOrEffect = IS_SERVER ? useEffect : useLayoutEffect;
